









































































import { Component, Vue, Prop } from "vue-property-decorator";
import Card from "./Card.vue";
import Table from "./Table.vue";
import PlayerArea from "./PlayerArea.vue";
import DeckConfigEditor from "./DeckConfigEditor.vue";
import { GameStore } from "@/stores/GameStore";
import { GlobalStore } from "@/stores/GlobalStore";
import { User } from "@/classes/User";

@Component({
  components: {
    Card,
    Table,
    PlayerArea,
    DeckConfigEditor
  }
})
export default class CardRoom extends Vue {
  @Prop() readonly globalStore!: GlobalStore;
  @Prop(String) readonly ownerUId!: string;
  private isShowConfig = false;
  private isDismissed = false;

  mounted() {
    //this.resetCards();
    Math.ceil;
  }

  resetSeats() {
    for (let index = 0; index < this.roomConfig.numberOfPlayers; index++) {
      this.gameStore.freeSeat(index);
    }
  }

  dismiss() {
    this.isDismissed = true;
  }

  showConfig() {
    this.isShowConfig = true;
  }

  hideConfig() {
    this.isShowConfig = false;
  }

  get gameStore() {
    return this.globalStore.activeRoom as GameStore;
  }

  get roomConfig() {
    return this.gameStore.roomConfig;
  }

  get isUserOwner() {
    const roomData = this.globalStore.rooms.get(this.globalStore.activeRoomKey);
    if (roomData != undefined) {
      return (
        roomData.owner.getUid() === (this.globalStore.user as User).getUid()
      );
    }
    return false;
  }
}
